var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(" Gegevens zijn gekopieerd "),
          ]),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c(
                "w-button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      return _vm.copyLoginUrl()
                    },
                  },
                },
                [
                  _c("div", [_c("w-fa", { attrs: { icon: "copy" } })], 1),
                  _c("div", [_vm._v("Loginurl kopiëren")]),
                ]
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c(
                "w-button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      return _vm.loginAsUser()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    [_c("w-fa", { attrs: { icon: "sign-in-alt" } })],
                    1
                  ),
                  _c("div", [_vm._v("Aanmelden als eigenaar")]),
                ]
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c(
                "w-button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      return _vm.openAccount()
                    },
                  },
                },
                [
                  _c("div", [_c("w-fa", { attrs: { icon: "pen" } })], 1),
                  _c("div", [_vm._v("Accountgegevens openen")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }